import React, { useState, useEffect } from 'react';
import { AxiosRequestConfig } from 'axios';
import { instance } from '../../services';
import { IMediaUploadProps } from './types';
import { IApiError } from '../../services';
import ErrorList from '../errorList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './MediaUpload.module.css';

// https://github.com/formium/formik/issues/45
// https://tympanus.net/codrops/2015/09/15/styling-customizing-file-inputs-smart-way/

const MediaUpload: React.FC<IMediaUploadProps> = ({
  id,
  url,
  className,
  children,
  onChange,
  onUploadProgress,
}) => {
  const [progress, setProgress] = useState<number>(-1);
  const [errors, setErrors] = useState<Array<string>>([]);

  useEffect(() => {
    if (onUploadProgress) {
      onUploadProgress(progress);
    }
  }, [progress, onUploadProgress]);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files || e.target.files.length === 0) {
      return;
    }

    let file = e.target.files[0];

    let data = new FormData();
    data.append('file', file);

    let config: AxiosRequestConfig = {
      onUploadProgress: (p: any) => {
        setProgress(Math.round((p.loaded * 100) / p.total));
      },
    };

    setErrors([]);
    setProgress(0);

    instance.post(url, data, config).then(
      (res) => {
        setProgress(-1);
        onChange(id, res.data.path);
      },
      (err: IApiError) => {
        setErrors(err.messages);
        setProgress(-1);
      },
    );
  };

  return (
    <div>
      <ErrorList errors={errors} />

      <input
        className={styles.inputFile}
        accept=".jpg,.jpeg,.png"
        name={`${id}File`}
        id={`${id}File`}
        type="file"
        onChange={handleFileChange}
      />
      <label htmlFor={`${id}File`} className={`mb-0 ${styles.cursorPointer} ${className}`}>
        {children ? (
          children
        ) : (
          <>
            <FontAwesomeIcon icon="upload" />
            <span className={styles.text}>Choose a file...</span>
          </>
        )}
      </label>

      {typeof onUploadProgress === 'undefined' && progress > -1 && (
        <div className="my-1"><small>Uploading ({progress}%)</small></div>
      )}
    </div>
  );
};

export default MediaUpload;
